<template>
  <v-app>
    <navigation-drawer-component></navigation-drawer-component>
    <header-component></header-component>
    <v-main>
        <router-view />
    </v-main>
    <footer-component></footer-component>
    <v-btn class="position-fixed overlay" size="x-large" icon="mdi-whatsapp" color="green" style="top: 50%; z-index: 1001; right: 5px;" href="https://wa.link/rrtb2e" target="_blank">
    </v-btn>
  </v-app>
</template>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');
  @import url('https://pro.fontawesome.com/releases/v5.10.0/css/all.css');

</style>

<script>
import FooterComponent from "@/views/FooterComponent.vue";
import HeaderComponent from "@/views/HeaderComponent.vue";
import NavigationDrawerComponent from "./components/NavigationDrawerComponent.vue";

export default {
  components: {
    FooterComponent,
    HeaderComponent,
    NavigationDrawerComponent
  },
};
</script>
